import { render, staticRenderFns } from "./AddServer.vue?vue&type=template&id=5e10ec82&"
import script from "./AddServer.vue?vue&type=script&lang=ts&"
export * from "./AddServer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports